<template>
  <div class="driver-overview-wrap">
    <div v-if="!isViewLoading">
      <driver-topbar
        :active-driver="activeDriver"
        :isFilterApplied="isFilterApplied"
        @toggleFilter="toggleFilter"
        @resetReportFilters="resetReportFilters"
      ></driver-topbar>
      <div class="driver-body-wrap">
        <driver-overview
          :active-driver="activeDriver"
          :activeSubdriver="activeSubdriver"
          :sortByData="sortByData"
        ></driver-overview>
        <subdrivers-heatmap
          :active-driver="activeDriver"
          :sort-by-data="sortByData"
          @onClickSortBy="onClickSortBy"
        ></subdrivers-heatmap>
        <driverUserResponses
        ></driverUserResponses>
      </div>
    </div>
    <drivers-filters
      ref="driversFilters"
      report-type="driver_engagement"
      @getReportWithFilter="getDriverWithFilter"
      @sortOptions="sortOptions"
    ></drivers-filters>
    <amara-loader
      v-if="isViewLoading"
    ></amara-loader>
  </div>
</template>

<script>
// import axios from 'axios';
import DriverTopbar from './driver-comp/driver-topbar';
import DriverOverview from './common-comp/driver-overview';
import SubdriversHeatmap from './driver-comp/subdrivers-heatmap';
import DriversFilters from './common-comp/drivers-filters';
import DriverUserResponses from './common-comp/drivers-user-responses';
import AmaraLoader from '../elements/amara-loader';
import DriversMixin from './drivers-mixins';

export default {
  name: 'Driver',

  mixins: [DriversMixin],

  components: {
    DriverTopbar,
    AmaraLoader,
    DriverOverview,
    DriversFilters,
    DriverUserResponses,
    SubdriversHeatmap
  },

  data () {
    return {
      // isDashLoading: true,
      isFilterApplied: false,
      isViewLoading: true,
      activeDriver: '',
      activeSubdriver: '',
      // pageOffset: 1,
      sortByData: {},
      sortByData1: {
        business: 'Business',
        cluster: 'Cluster',
        department: 'Department',
        gender: 'Gender',
        grade: 'Grade',
        hr_manager: 'HR Manager',
        hrbp: 'HR Business Partner',
        location: 'Location',
        site: 'Site'
      }
    };
  },

  created () {
    // this.getDrivers();
  },

  watch: {
    // driversList () {
    // if (!this.activeDriver) {
    //   this.activeDriver = this.driversList[0];
    // }
    // },
    // sortByData: {
    //   deep: true,
    //   handler () {
    //   }
    // }
    $route: {
      deep: true,
      immediate: true,
      handler () {
        if (this.$route && this.$route.query && this.$route.query.filters) {
          const updateReportFilters = JSON.parse(this.$route.query.filters);
          this.$store.dispatch('updateDriversFilters', updateReportFilters);
        }
        if (this.$route.query && this.$route.query.driver) {
          if (this.activeDriver !== '' && (this.activeDriver !== this.$route.query.driver)) {
            this.activeDriver = this.$route.query.driver;
            this.getDriverAnalysis();
          }
          this.activeDriver = this.$route.query.driver;
          this.getDriversResponses();
        }
      }
    }
  },

  methods: {
    // getRating (val) {
    //   this.getResponsesWithRate(val);
    // },
    // getSentiment (val) {
    //   this.getResponsesWithSentiment(val);
    // },
    resetReportFilters () {
      // console.log('resetReportFiltersewgweweg');
      if (this.$refs && this.$refs.driversFilters) {
        this.$refs.driversFilters.resetFilters();
        this.$router.push({
          path: '/drivers/view',
          query: {
            driver: this.activeDriver
          }
        }).catch(() => {});
      }
    },
    getDriverWithFilter (val) {
      // console.log('getDriverWithFilter -> val', val);
      this.isFilterApplied = val;
      // if (val) {
      this.getDriverAnalysis();
      // this.getDriversResponses();
      // }
    },
    toggleFilter () {
      if (this.$refs.driversFilters) {
        this.$refs.driversFilters.showFilterDrawer = !this.$refs.driversFilters.showFilterDrawer;
      }
    },
    onClickSortBy (sortBy) {
      this.getEngagementHeatMap(sortBy);
    },
    sortOptions (val) {
      this.sortByData = val;
    }
    // onClickDriverCard (driver) {
    //   this.activeDriver = driver;
    //   if (driver) {
    //     this.getDriverAnalysis();
    //   }
    //   if (this.sortByData) {
    //     const opt = Object.entries(this.sortByData)[0];
    //     if (opt) {
    //       this.getEngagementHeatMap(opt[0]);
    //     }
    //   }
    // },
    // getResponses (val) {
    //   this.pageOffset = val;
    //   this.getResponsesWithRate();
    // },
    // getDrivers () {
    //   this.isDashLoading = true;
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/list`).then((response) => {
    //     if (response.status === 200) {
    //       this.driversList = response.data.drivers;
    //       this.$nextTick(() => {
    //         this.isDashLoading = false;
    //         this.getDriverAnalysis(this.activeDriver);
    //       });
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // },
    // getResponsesWithSentiment (val) {
    //   const filters = Object.assign({}, this.updateDriversFilters);
    //   if (filters && filters.filters) {
    //     delete filters.filters;
    //   }
    //   const queryParams = {
    //     fields: 'response_list',
    //     response__response_sentiment__range: val,
    //     responses_count: true,
    //     ...filters
    //   };
    //   if (this.updateDriversFilters && this.updateDriversFilters.filters) {
    //     this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
    //       if (v.length > 0) {
    //         queryParams[`user__profile__${k}__in`] = v.join();
    //       }
    //     });
    //   }
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
    //     params: queryParams
    //   }).then((response) => {
    //     if (response.status === 200) {
    //       if (response.data && response.data.interaction_responses) {
    //         this.$store.dispatch('driversResponses', response.data.interaction_responses);
    //       }
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // },
    // getResponsesWithRate (val) {
    //   const filters = Object.assign({}, this.updateDriversFilters);
    //   if (filters && filters.filters) {
    //     delete filters.filters;
    //   }
    //   const queryParams = {
    //     fields: 'response_list',
    //     response__value__in: val || undefined,
    //     responses_count: true,
    //     page_offset: this.pageOffset,
    //     ...filters
    //   };
    //   if (this.updateDriversFilters && this.updateDriversFilters.filters) {
    //     this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
    //       if (v.length > 0) {
    //         queryParams[`user__profile__${k}__in`] = v.join();
    //       }
    //     });
    //   }
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
    //     params: queryParams
    //   }).then((response) => {
    //     if (response.status === 200) {
    //       if (response.data && response.data.interaction_responses) {
    //         this.$store.dispatch('driversResponses', response.data.interaction_responses);
    //       }
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.driver-overview-wrap {
  // .drivers-cards-wrap {
  //   box-shadow: 0px 6px 8px 1px rgba(0, 0, 0, 0.1);
  //   background-color: var(--bg);
  //   min-height: 100vh;
  // }
  .driver-body-wrap {
    margin: 0 12px;
    .driver-lifecycle-wrap {
      // margin-right: 12px;
      // padding: 36px 0px;
      .lifecycle-wrap {
        padding: 16px;
        height: 15rem;
        background-color: var(--bg);
        border-radius: 0.375rem !important;
        position: relative !important;
        border: none !important;
        box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
        box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
        .lifecycle-heading {
          text-align: center;
          color: var(--color-text);
          padding-bottom: 12px;
        }
      }
    }
  }
}
</style>
